import * as ss from 'superstruct';
import { Id } from '../../types';
import { FunnelStageResource } from './funnel-stage.resource';
import { ConversionSource } from '../conversion-source';

export const FunnelStageAssignmentResource = ss.type({
  id: Id,
  /** The stage this source + eventType are assigned to. */
  stage: FunnelStageResource,
  /** The source of the event. */
  source: ConversionSource,
  /** The type of event. */
  eventType: ss.string(),
});

export type FunnelStageAssignmentResource = ss.Infer<
  typeof FunnelStageAssignmentResource
>;
